export const Shower = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 29H10V8C10 5.23858 12.2386 3 15 3V3C17.7614 3 20 5.23858 20 8V8" stroke="currentColor" stroke-width="2"/>
<path d="M15 13C15 10.2386 17.2386 8 20 8C22.7614 8 25 10.2386 25 13H15Z" stroke="currentColor" stroke-width="2"/>
<path d="M24 16V18" stroke="currentColor" stroke-width="2"/>
<path d="M20 16V18" stroke="currentColor" stroke-width="2"/>
<path d="M16 16V18" stroke="currentColor" stroke-width="2"/>
<path d="M24 20V22" stroke="currentColor" stroke-width="2"/>
<path d="M20 20V22" stroke="currentColor" stroke-width="2"/>
<path d="M16 20V22" stroke="currentColor" stroke-width="2"/>
<path d="M24 24V26" stroke="currentColor" stroke-width="2"/>
<path d="M20 24V26" stroke="currentColor" stroke-width="2"/>
<path d="M16 24V26" stroke="currentColor" stroke-width="2"/>
</svg>`;
